<div class="modal-succes-register text-center">
  <h1 class="uppercase">{{ 'ALMOST_DONE' | translate }}</h1>
  <p class="uppercase">{{ 'SUCCES_REGISTER' | translate }}</p>
  <button mat-raised-button color="primary" (click)="goToLogin()" mat-dialog-close [mat-dialog-close]="false"
    class="uppercase">{{ 'GO_TO_LOGIN' | translate
    }}</button>
</div>
